import { Button } from 'components'
import React from 'react'
import './interactions.scss'
import { FollowUpIcon } from 'assets'

type InteractionFollowupType = {
    interactionHandler: (interaction: {
        name: string
        outcome: string
        date_scheduled: Date
    }) => void
    followupInteraction: {
        interactionName: string
        interactionOutcome: string
    }
    setFollowupInteraction: React.Dispatch<
        React.SetStateAction<{
            interactionName: string
            interactionOutcome: string
        } | null>
    >
    t: (key: string, params?: Record<string, number>) => string
}

export const InteractionFollowup = ({
    interactionHandler,
    followupInteraction,
    setFollowupInteraction,
    t
}: InteractionFollowupType) => {
    const weeks = Array.from(Array(5).keys())

    const getWeekSchedule = (week: number) => {
        const date = new Date()
        date.setDate(date.getDate() + 7 * week)
        return date
    }

    return (
        <div
            className="interaction-followup"
            aria-label="interaction-followup-modal"
        >
            <div className="interaction-followup--top-header">
                <div className="interaction-followup--icon">
                    <FollowUpIcon />
                </div>
                <p className="interaction-followup--title">
                    {t('clientDetails.requestFollowUp')}
                </p>
            </div>
            <div className="interaction-followup--weeks">
                {weeks.map((week, index) => {
                    const weeksCount = index + 1
                    return (
                        <Button
                            size="large"
                            key={week + index}
                            style="primary"
                            className="interaction-followup--button"
                            onClick={() => {
                                interactionHandler({
                                    name: followupInteraction.interactionName,
                                    outcome:
                                        followupInteraction.interactionOutcome,
                                    date_scheduled: getWeekSchedule(weeksCount)
                                })
                                setFollowupInteraction(null)
                            }}
                            ariaLabel={`followup-${weeksCount}-week`}
                        >
                            {t('week', { count: weeksCount })}
                        </Button>
                    )
                })}
            </div>
        </div>
    )
}
